import { useState, useEffect, useMemo } from "react";
import { Box, DialogActions, DialogContent, IconButton, Grid, Button, Typography } from "@mui/material";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import WeekDropdown from "../../../atom/Inputs/WeekDropdown";
import { getText } from "../../../../core/Constant";
import { Actions } from "../../../../core/modules/Actions";
import { connect, useDispatch } from 'react-redux';
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import TableComponent from "../../../atom/Table/TableComponent";
import DeleteIcon from "@mui/icons-material/Delete";
import SelectQuizModal from "./SelectQuizModal";
import SectionTypeIcon from "../../../atom/Icons/SectionTypeIcon";


const AdminCourseWeekQuiz = ({ open, onClose, courseID, weekNo, dayNo, courseQuizList, getCourseQuizList, sectionName }) => {
    const dispatch = useDispatch();
    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(false);
    const [titleErrorMsg, setTitleErrorMsg] = useState('Please add the title');
    const [titalValid, setTitleVaid] = useState(false);

    const [link, setLink] = useState('');
    const [linkError, setLinkError] = useState(false);
    const [isLinkValid, setIsLinkVaid] = useState(false);

    const [duration, setDuration] = useState('');
    const [durationError, setDurationError] = useState(false);
    const [durationErrorMsg, setDurationErrorMsg] = useState('Please add the valid duration');
    const [isDurationValid, setDurationValid] = useState(false);

    const [newWeekContent, setNewWeekContent] = useState([]);
    const [addedQuizList, setAddedQuizList] = useState([]);

    const [day, setDay] = useState('');
    const [dayError, setDayError] = useState(false);
    const [isDayValid, setDayValid] = useState(false);

    const [saveBtnValidMsg, setSaveBtnValidMsg] = useState('');
    const [selectedQuizName, setSelectedQuizName] = useState("");
    const [selectedQuizFolderStack, setSelectedQuizFolderStack] = useState([]);
    const [openSelectModal, setOpenSelectModal] = useState(false);

    useEffect(() => {
        if (!open) {
            setTitle("");
            setLink("");
            setDuration("");
            setDay("");
            setTitleVaid(false);
            setIsLinkVaid(false);
            setDurationValid(false);
            setDayValid(false);
            setLinkError(false);
            setDurationError(false);
            setTitleError(false);
            setTitleErrorMsg("Please add the title");
            setDayError(false);
            setNewWeekContent([]);
            setSaveBtnValidMsg('');
            setSelectedQuizName("");
            setSelectedQuizFolderStack([]);
            setOpenSelectModal(false);
        }
    }, [open]);

    const addToList = () => {

        setSaveBtnValidMsg('');
        if (isLinkValid && isDurationValid && titalValid && isDayValid) {
            setNewWeekContent([
                ...newWeekContent,
                { "content_type": '2', 'content': title, 'link': "" + link + "", 'duration': duration, 'day': String(day), 'is_locked': '1' }
            ]);

            setTitle("");
            setLink("");
            setDuration("");
            setDay("");
            setTitleVaid(false);
            setIsLinkVaid(false);
            setDurationValid(false);
            setDayValid(false);
            setLinkError(false);
            setDurationError(false);
            setTitleError(false);
            setTitleErrorMsg("Please add the title");
            setDayError(false);
            setSelectedQuizName("");
            setSelectedQuizFolderStack([]);

        } else {
            if (!isLinkValid) {
                setLinkError(true);
            }
            if (!isDurationValid) {
                setDurationError(true);
            }
            if (!titalValid) {
                setTitleError(true);
                if (title && title.length > 255) {
                    setTitleErrorMsg("Maximum 255 characters allowed.");
                } else {
                    setTitleErrorMsg("Please add the title");
                }
            }
            if (!isDayValid) {
                setDayError(true);
            }
        }


    };

    const removeFromList = (index) => {
        const updatedList = newWeekContent.filter((_, i) => i !== index);
        setNewWeekContent(updatedList);
    };

    const columns = useMemo(() => [
        {
            name: "day",
            label: "Day",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => `Day ${value}`,
            },
        },
        {
            name: "content",
            label: "Title",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value,
            },
        },
        {
            name: "link",
            label: "Quiz",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => {
                    const quiz = addedQuizList.find((q) => String(q.id) === String(value));
                    return quiz ? quiz.name : value;
                },
            },
        },
        {
            name: "duration",
            label: "Duration (Min)",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value,
            },
        },
        {
            name: "action",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;
                    return (
                        <IconButton onClick={() => removeFromList(rowIndex)}>
                            <DeleteIcon style={{ color: "#9E9E9E" }} />
                        </IconButton>
                    );
                },
            },
        },
    ], [addedQuizList, newWeekContent]);

    useEffect(() => {

        if (courseID) {
            getCourseQuizList(courseID)
        } else {

        }
        setSaveBtnValidMsg('');
    }, [courseID, sectionName])

    useEffect(() => {
        setAddedQuizList(courseQuizList);
    }, [courseQuizList]);

    const onTitleChange = (e) => {
        const text = getText(e);
        setTitle(text);
        if (text && text.length > 255) {
            setTitleError(true);
            setTitleErrorMsg("Maximum 255 characters allowed.");
            setTitleVaid(false);
        } else {
            setTitleError(false);
            setTitleErrorMsg("Please add the title");
            const isValid = text?.trim().length > 0;
            setTitleVaid(isValid);
        }
    }

    const onLinkChange = (e) => {
        const text = getText(e)
        setLink(text);
        setLinkError(false)
        const isValid = text > 0;
        setIsLinkVaid(isValid);
    }

    const onDurationChange = (e) => {
        const rawText = getText(e) || "";
        const cleanText = rawText.replace(/[^0-9]/g, "");
        setDuration(cleanText);
        setDurationError(false);
        const isValid = cleanText.length > 0 && Number(cleanText) > 0;
        setDurationValid(isValid);
    }

    const onDayChange = (event) => {
        const val = getText(event);
        const isValid = val !== undefined && val !== "";
        setDay(val);
        setDayError(!isValid);
        setDayValid(isValid);
    }

    const handleQuizSelect = (quiz, parentId, folderStack) => {
        setLink(String(quiz.id));
        setSelectedQuizName(quiz.name);
        setSelectedQuizFolderStack(folderStack);
        const qName = quiz.name || "";
        setTitle(qName);
        if (qName.length > 255) {
            setTitleError(true);
            setTitleErrorMsg("Maximum 255 characters allowed.");
            setTitleVaid(false);
        } else {
            setTitleError(false);
            setTitleErrorMsg("Please add the title");
            setTitleVaid(qName.length > 0);
        }
        setLinkError(false);
        setIsLinkVaid(true);
        if (quiz.duration) {
            const quizDuration = String(quiz.duration);
            setDuration(quizDuration);
            setDurationValid(Number(quizDuration) > 0);
            setDurationError(false);
        }
        setOpenSelectModal(false);
    };

    const saveAddedWeekContent = () => {

        if (newWeekContent.length > 0) {

            var json_request_data = '{"course_id": "' + courseID + '","weeks": [ {"week": "' + sectionName + '","details": ' + JSON.stringify(newWeekContent) + '}]}';

            dispatch(Actions.course.createCourseContent(JSON.parse(json_request_data)))
            onClose();


        } else {

            setSaveBtnValidMsg('Please add at least one quiz');


        }
    }

    return (
        <>
            <form>
                <DialogContent>
                    <Box className="admin-course-content-form-wrap">
                        <Grid container spacing={2} alignItems="flex-start" className="admin-course-input-group">
                            {/* Day */}
                            <Grid item xs={12} md={2}>
                                <WeekDropdown
                                    selectedValue={day}
                                    onchange={onDayChange}
                                    isError={dayError}
                                    error="Please select a day"
                                    readOnly={false}
                                />
                            </Grid>
                            {/* Links */}
                            <Grid item xs={12} md={3}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "100%",
                                        padding: "10px"
                                    }}
                                >
                                    <p
                                        style={{
                                            padding: 0,
                                            margin: 0,
                                            marginBottom: 10,
                                            color: "#4E657C",
                                            fontSize: 19,
                                            fontWeight: 700,
                                        }}
                                    >
                                        Quiz
                                    </p>
                                    <Box
                                        onClick={() => setOpenSelectModal(true)}
                                        className="form-control"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            borderRadius: "8px",
                                            border: linkError ? "1.5px solid #d32f2f" : "1.5px solid #CCCCCC",
                                            cursor: "pointer",
                                            backgroundColor: "#FFFFFF",
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, overflow: "hidden" }}>
                                            {link ? (
                                                <>
                                                    <SectionTypeIcon contentType={2} sx={{ fontSize: 25, color: "#9834F0" }} />
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            color: "#495057",
                                                            fontWeight: 400,
                                                            fontFamily: "Montserrat",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            direction: "rtl",
                                                            textAlign: "left",
                                                            mr: 1
                                                        }}
                                                    >
                                                        {selectedQuizName}
                                                    </Typography>
                                                </>
                                            ) : (
                                                <Typography
                                                    sx={{
                                                        fontSize: "14px",
                                                        color: "#8C8C8C",
                                                        fontFamily: "Montserrat",
                                                    }}
                                                >
                                                    Select Quiz
                                                </Typography>
                                            )}
                                        </Box>
                                        <Button
                                            variant="text"
                                            sx={{
                                                textTransform: "none",
                                                color: "#9834F0",
                                                fontWeight: 600,
                                                fontFamily: "Montserrat",
                                                padding: 0,
                                                minWidth: "auto",
                                                fontSize: "14px",
                                                "&:hover": { backgroundColor: "transparent" },
                                            }}
                                        >
                                            {link ? "Change" : "Browse"}
                                        </Button>
                                    </Box>
                                    {linkError && (
                                        <Typography
                                            sx={{
                                                color: "#d32f2f",
                                                fontSize: "12px",
                                                fontFamily: "Montserrat",
                                                marginLeft: "14px",
                                                marginTop: "4px",
                                            }}
                                        >
                                            Please select a quiz
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                            {/* Title */}
                            <Grid item xs={12} md={3}>
                                <TextInputComponent
                                    label={"Title"}
                                    isError={titleError}
                                    placeholder="Enter Title"
                                    name={"title"}
                                    value={title}
                                    error={titleErrorMsg}
                                    onchange={onTitleChange}
                                />
                            </Grid>
                            {/* Duration */}
                            <Grid item xs={12} md={3}>
                                <TextInputComponent
                                    label={"Duration (MIN)"}
                                    isError={durationError}
                                    placeholder="Duration (MIN)"
                                    name={"duration"}
                                    value={duration}
                                    error={durationErrorMsg}
                                    type="text"
                                    onchange={onDurationChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={1}>
                                <Box sx={{ mt: 5.5 }}>
                                    <TextButtonComponet text={"Add"} width={60} onButtonClick={() => addToList()} />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {newWeekContent.length > 0 ? (
                        <Box p={3}>
                            <Box mt={4} justifyContent="center" alignItems="center">
                                <HeadingComponent text={"Added Quiz"} fontweigth={600} size={25} fontfamily={"Montserrat"} />
                            </Box>
                            <Box mt={2} sx={{ border: "1px solid #E0E0E0", borderRadius: "10px", overflow: "hidden" }}>
                                <TableComponent
                                    columns={columns}
                                    data={newWeekContent}
                                    filter={false}
                                    search={false}
                                    download={false}
                                    selectableRowsHideCheckboxes={true}
                                    elevation={0}
                                    pagination={false}
                                />
                            </Box>
                        </Box>
                    ) : null}
                    <Box>
                        <b> <p className="text-center" style={{ color: 'red' }}>{saveBtnValidMsg}</p></b>
                    </Box>

                </DialogContent>
                <DialogActions sx={{ mr: 2, mb: 2 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <TextButtonComponet text={"Cancel"} classStyle="btn btn-secondary" width={120} onButtonClick={() => onClose()} />
                        <TextButtonComponet text={"Save"} width={120} onButtonClick={() => saveAddedWeekContent()} />
                    </Box>

                </DialogActions>
            </form>
            <SelectQuizModal
                open={openSelectModal}
                onClose={() => setOpenSelectModal(false)}
                courseID={courseID}
                onSelect={handleQuizSelect}
                initialFolderStack={selectedQuizFolderStack}
                selectedQuizId={link}
            />
        </>
    );
}

export default connect(
    state => ({
        courseQuizList: state.course.get("courseQuizList"),
        loadingAction: state.common.get("loadingAction")
    }), {
    getCourseQuizList: Actions.course.getCourseQuizList,
}
)(AdminCourseWeekQuiz);